<template>
  <el-table
        stripe
    size="mini"
    :data="tableData"
    height="0"
    class="flex-grow-1"
    :class="{'dark':skinType}"
    :row-class-name="(...nu)=>{return skinType?'dark text-white':''}"
  >
    <el-table-column prop="TabID" width="50" label="#" align="center">
    </el-table-column>
    <el-table-column prop="EquipmentName"  label="名称" minWidth="80" align="center">
    </el-table-column>
    <el-table-column prop="EDingRongLiang" width="80" label="容量(kVA)" align="center">
    </el-table-column>
    <el-table-column prop="ZuiGaoFuHe" width="96" label="最高负荷(kW)" align="center">
    </el-table-column>
    <el-table-column prop="KeKaiFangRongLiang" width="120" label="可开放容量(kVA)" align="center">
    </el-table-column>
  </el-table>
</template>

<script>
import TurnAskingMixin from '@/mixins/turn-ask';
import { getcapacity } from '../../../api/statistical-analysis/statisticalanalysis';

export default {
  mixins: [TurnAskingMixin],
  data() {
    return {
      tableData: [],
      timeOut: null,
    };
  },
  props: {
    select: String,
  },
  watch: {
    select() {
      this.requestOpenCapacity();
    },
  },
  created() {
    this.requestOpenCapacity();
  },
  computed: {
    skinType() {
      return this.$store.getters.skinType;
    },
  },
  methods: {
    // 请求可开放容量
    requestOpenCapacity() {
      if (!this.select) {
        this.tableData = [];
        return;
      }
      clearTimeout(this.timeOut);
      getcapacity({
        StationIdStr: this.select,
      }).then((res) => {
        this.tableData = res;
      }).catch(() => {
        this.tableData = [];
      }).then(() => {
        this.timeOut = this.turnAsking({
          routeName: this.routeName,
          nowRouteName: this.$route.name,
          func: this.requestOpenCapacity,
        }, 5 * 1000);
      });
    },
  },
};
</script>
<style scoped>
table {
  background: #898a8a;
}
</style>
